export const SYNCCONTENT_FIELD = [{
    name: '商品名称',
    value: 'title'
  },{
    name: '商品主图',
    value: 'mainImages'
  },{
    name: 'sku编码',
    value: 'skuOuterId'
  },{
    name: 'sku图片',
    value: 'imageUrl'
  },{
    name: '重量',
    value: 'weight'
  },{
    name: '销售价',
    value: 'salesPrice'
  },{
    name: '市场价',
    value: 'marketPrice'
  },{
    name: '成本价',
    value: 'purchasePrice'
  },{
    name: '规格',
    value: 'skuSpecifications'
  },{
    name: '商品供应商',
    value: 'cgSupplierId'
  },{
    name: '类目和类目属性',
    value: 'categoryInfo'
  },{
    name: '商品标签',
    value: 'itemLabel'
}]

export const SYNCCONTENT_FIELD_SYSTEM = [
  {
    name: '商品名称',
    value: 'title'
  },
  {
    name: '商品主图',
    value: 'mainImages'
  },
  {
    name: 'sku编码',
    value: 'skuOuterId'
  },
  {
    name: 'sku图片',
    value: 'imageUrl'
  },
  {
    name: '重量',
    value: 'weight'
  },
  {
    name: '销售价',
    value: 'salesPrice'
  },
  {
    name: '成本价',
    value: 'purchasePrice'
  },
  {
    name: '商品供应商',
    value: 'cgSupplierId'
  }
]

export const SYNCCONTENT_MAP = {
  'title': '商品名称',
  'mainImages': '商品主图',
  'skuOuterId': 'sku编码',
  'imageUrl': 'sku图片',
  'weight': '重量',
  'salesPrice': '销售价',
  'purchasePrice': '成本价',
  'skuSpecifications': '规格',
  'cgSupplierId': '商品供应商',
  'marketPrice': '市场价',
  'stock': '库存',
  'categoryInfo': '类目和类目属性',
  'itemLabel': '商品标签',
  'baseSellingPrice': '基本售价',
}